import { FunctionComponent } from 'react';

import { ProfileContainer } from '@components/Profile/Profile.container';

export const AppRoutes: Record<string, FunctionComponent<any>> = {
  '/': ProfileContainer,
  '/profile': ProfileContainer,
};
